export default __webpack_public_path__ + "static/inner-belief_small-image_1-60c47e93a00e4982017b890255544ce8.webp";